<template>
   	<div class="header">
   		<div class="searchBox">
   			<input v-model="searchText" type="text" class="txt" placeholder="曲目、歌手搜索" @keyup.enter="searchSong"/>
   			<div class="search" @click="searchSong" :class="{search2:searchFlag==1}"></div>
   		</div>
   	</div>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
      	searchText:"",

      }
    },
    computed: {
    	...mapGetters(['searchFlag'])
    },
    methods: {
      searchSong:function(){
      	this.$store.commit('bigPlayShow',false);
      	this.$store.commit('setMainNum',0);
      	this.$store.commit('searchFlag',1);
      	function trim(s){
		    return s.replace(/(^\s*)|(\s*$)/g, "");
		}
      	if(trim(this.searchText)==''){
      		this.searchText='西瓜';
      	}
      	this.$router.push({path: '/search'})
      	this.$store.commit('setGuodu', true);
      	this.$store.commit('setIscurrent', -1);
      	var _this=this;
      	$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/searchSongList?name="+_this.searchText,
			dataType:"json",
			success: function(data){
				var songList = [];
				var temp=data.data.info;
				for(var i=0;i<temp.length;i++){
					var song={};
					song.title=temp[i].filename;
					song.hash=temp[i].hash;
					songList.push(song);
					_this.$store.commit('setSearchTotal',data.data.total);
				}
				_this.$store.commit('setGuodu', false);
				_this.$store.commit('setSongList', songList);
			}
		});
      },
    }
  }
</script>

<style>
.header{width: 100%;height: 70px;background: #000;overflow: hidden;position: fixed;z-index: 13;top:0;}
.searchBox{width: 83%;height: 45%;margin: 24px auto 0;background: #ccc;}
.txt{float: left;width: 86%;height: 100%;background: #fff;box-sizing: border-box;padding-left: 12px;outline: none;border: none;font-size:14px;font-family: "微软雅黑";}
.search{width: 14%;height: 100%;background: #242424 url(../assets/images/search.png) no-repeat center center;background-size:40%; float: left;}
.search2{background: #242424 url(../assets/images/search2.png) no-repeat center center;background-size:40%;border-bottom: 2px solid #7de87d;box-sizing: border-box;}
</style>


// WEBPACK FOOTER //
// header.vue?599d4c9f